import React, { Component } from "react";
import { Scrollbars } from "react-custom-scrollbars-2";
import { connect } from "react-redux";
import TableCart from "../Components/TableCart";
import ProductGrid from "../../Components/Product/ProductGrid";
import MostRecent from "../../Components/Product/MostRecent";
import CategorySlider from "../../Components/Product/CategorySlider";
import ProductFilter from "../../Components/Product/ProductFilter";
class Dashboard extends Component {
  render() {
    return (
      <div className="row">
        <TableCart />
        <div className="col-md-8">
          <div className="row ">
            <div className="col-12">
              {this.props.RecentView && this.props.RecentView.length !== 0 ? (
                <MostRecent />
              ) : (
                <CategorySlider />
              )}
            </div>
            <div className="col-12">
              <ProductFilter />
            </div>

            <div className="col-12">
              <Scrollbars
                style={{ height: "calc(100vh - 51ex)" }}
                className="card"
              >
                <div className="card-body">
                  <ProductGrid />
                </div>
              </Scrollbars>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default connect(
  (state) => ({
    RecentView: state.Cart.RecentView,
  }),
  {}
)(Dashboard);
